import FiftyOnetripsLogo from "../assets/images/51trips-logo.webp";
import mockupAgencies from "../assets/images/MockupAgencias.png";
import {useTranslation} from "react-i18next";
export const MobileTabletPage = () => {

    const {t} = useTranslation()
    return (
        <div className="bg-[#F4F0EA] w-full h-[100vh] flex flex-col items-center p-10 pt-[20%]">
            <img src={FiftyOnetripsLogo} alt="" className="w-28 mb-8"/>
            <img src={mockupAgencies} className="w-2/3"/>
            <div className="mt-2  text-[25px] font-medium text-neutralBlack-900 text-center">{t('onlyDesktopViewTitle',{ns:'dashboard'})}</div>
            <div className="mt-2 text-[16px] text-neutralBlack-900 text-center">{t('onlyDesktopViewDescription',{ns:'dashboard'})}</div>

        </div>
    )
}
